/* src/app/components/shared/pack-carousel/pack-carousel.component.scss */
.card-size {
  width: 150px !important;
  margin-right: 16px !important;
}
.card-height {
  height: 60px;
}
/*# sourceMappingURL=pack-carousel.component.css.map */
